var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uploader"},[_vm._t("default",function(){return [_c('uploader-unsupport'),_vm._v(" "),_c('uploader-drop',[_c('uploader-btn',[_vm._v("点击或拖拽上传")])],1),_vm._v(" "),_c('uploader-list')]},{"files":_vm.files,"fileList":_vm.fileList,"started":_vm.started})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29d0991e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload/components/uploader.vue
// module id = null
// module chunks = 